<div class="category-group">
    <div class="mt-3 ml-1 category-header-gradient">
        <button
            pButton
            style="font-weight: 700; font-size: 1.45rem;"
            type="button"
            text
            severity="contrast"
            class="w-full"
            [label]="category.CategoryName"
            uiSref="category.detail"
        ></button>
    </div>

    <div class="mt-3">
        <ef-process-list [category]="category"></ef-process-list>
    </div>
</div>
